import React, { useState,useEffect } from 'react'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import {IoMdSearch, IoMdHome, IoMdClose} from 'react-icons/io'
import 'font-awesome/css/font-awesome.min.css';

import { GiHamburgerMenu } from "react-icons/gi"
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import {config} from '../config'
import TourneyCountdown from './TourneyCountdown.js';
import ShowPinnedTournaments from './showPinnedTournaments.js'
import * as txApi from '../clients/tx-sls-client'

const txdomain = config()['tourneyx-url']

const Header = ({hideLinks = false, user_information, upcoming_tourney_countdown,get_pinned_tournaments}) => {
 
  var setPinnedTournaments = [];
  const [openMenuId, setOpenMenuId] = useState()
  const [tourneyName, setTourneyName] = useState('')
  const [cityState, setCityState] = useState('')
  const [isShowPinIcon, setPinLoaded] = useState(false)

  const setOnChange = (setfn) => (event) => setfn(event.target.value)
  
  //console.log('user_information passed in header section:::', user_information)

  
  //const set_user_information = user_information;
  //console.log('set_user_information value:::',set_user_information );
  

  //console.log('upcoming tournament countdown value received:::', upcoming_tourney_countdown);
  //console.log('get_pinned_tournaments length passed in header section:::', get_pinned_tournaments);
  
  if (!isShowPinIcon) {
    if(get_pinned_tournaments.length > 0 && (user_information && user_information.user_id !== null)){
      console.log('This should be called once')
      setPinLoaded(true)
    }else{}
 
  }else{

  }

   // Get upcoming_tourney_countdown and convert it to users timezone 

  /*
      const refer_timezone  = Intl.DateTimeFormat().resolvedOptions().timeZone;
      console.log('Refer timezone value found::', refer_timezone);

    
      const upcoming_time = moment(upcoming_tourney_countdown).tz(refer_timezone).format('YYYY-MM-DD HH:mm:ss');
      console.log('Countdown upcoming_time variable output:::', upcoming_time);


      const refer_now = moment().tz('UTC').format('YYYY-MM-DD HH:mm:ss');
      console.log('Countdown refer_now variable output:::', refer_now);

      
      if( upcoming_time > refer_now ){
      }else{
      }   
  */

  const search = (x) => {
    x.preventDefault()
    const cityStatePath = cityState ? cityState.split(' ').join('').split(',').join('/') : 's'

    // const searchPath = `${txdomain}/app/tournaments/${cityStatePath}/${tourneyName}`
    // Chaitraly 09/Jul/2024 :: TP-372 Jira card :: Global search redirection
    const searchPath = `${txdomain}/app/global_search/${cityStatePath}/${tourneyName}`

    document.getElementById("searchForm").reset()
    window.location.href = searchPath
  }

  const toggleMenu = (menuId) => {

    //console.log('menuId value passed in regular toggleMenu:::', menuId);

    if(menuId) {
      setOpenMenuId(menuId)
    } else {
      menuId = openMenuId
    }

    if(menuId) {
      const menu = document.getElementById(menuId)
      menu.classList.toggle("hidden")
    }

    const menuLink = document.getElementById("menuLink")
    const searchLink = document.getElementById("searchLink")
    const homeLink = document.getElementById("homeLink")
    const closeLink = document.getElementById("closeLink")
    const pinnedLink = document.getElementById("nav-pinned")

    searchLink.classList.toggle("hidden")
    menuLink.classList.toggle("hidden")
    homeLink.classList.toggle("hidden")
    closeLink.classList.toggle("hidden")
    pinnedLink.classList.toggle("hidden")
  }

  const togglePinnedMenu = (menuId) => {
    console.log('menuId value passed in togglePinnedMenu:::', menuId);

    if(menuId) {
      setOpenMenuId(menuId)
    } else {
      menuId = openMenuId
    }

    if(menuId) {
      const menu = document.getElementById(menuId)
      menu.classList.toggle("hidden")
    }

    const menuLink = document.getElementById("menuLink")
    const searchLink = document.getElementById("searchLink")
    const homeLink = document.getElementById("homeLink")
    const closeLink = document.getElementById("closeLink")
    const pinnedLink = document.getElementById("nav-pinned")

    searchLink.classList.toggle("hidden")
    menuLink.classList.toggle("hidden")
    homeLink.classList.toggle("hidden")
    closeLink.classList.toggle("hidden")
    pinnedLink.classList.toggle("hidden")


  }

  useEffect(() => {
  },[]);
  

return (
  <>

<Navbar fixed="top" collapseOnSelect expand="lg">
    <div className="header-wrapper">
      <div className="header-left">
        <Navbar.Brand href={`${txdomain}/app`}>
          
            <img className="d-inline-block align-top header-img"
              src="/leaderboard/logo.png"
              alt="TourneyX Logo"
            />
          
        </Navbar.Brand>
      </div>

      <div className={hideLinks ? 'hidden' : 'header-right'}>
        <Nav>
          <Navbar.Text>
            
              
            <div className='nav-circle'>
              <a id='menuLink' href="#" onClick={() => toggleMenu("rightMenu")}>
                  <GiHamburgerMenu  className='side-menu-header-icon'/>
              </a>
              
              <a id='closeLink' className='hidden' href="#" onClick={() => toggleMenu()}>
                  <IoMdClose className='header-icon' />
              </a>
            </div>   

            <div id='homeLink' className='nav-circle'>
              <a href={`${txdomain}/app`} className="right-menu-icons">
                {
                  /*
                      <IoMdHome  className='header-icon'/>
                   */
                }
                <i className="essentials-home"></i>
              </a>
            </div>

            <div id='searchLink' className='nav-circle'>
              <a href="#" onClick={() => toggleMenu("leftMenu")} className="right-menu-icons">
                { /*
                    <IoMdSearch  className='header-icon'/>
                */
                
                }
                <i className="essentials-search"></i>
              </a>
            </div>

            {
             isShowPinIcon ?
              <div id="nav-pinned">
               <a href="#" onClick={() => togglePinnedMenu("leftPinnedMenu")} className="right-menu-icons">
                  <i className="fa fa-thumb-tack"></i>  
               </a> 
              </div> 
              : null
             
            }

            <TourneyCountdown date={`${upcoming_tourney_countdown}`} />
            
          
          </Navbar.Text>
        </Nav>
      </div>

    </div>
    
  </Navbar>

  <div id="rightMenu" className='right-nav-menu hidden' >

      {

        
        (user_information && user_information.user_id !== null) ? 
        
        <ul className="sideMenuList">
          <li><a className='sideMenuLinks' href={`${txdomain}`}>TourneyX</a></li>
          <li><a className='sideMenuLinks' href={`${txdomain}/app/tournaments/`}>Tournaments</a></li>
          <li><a className='sideMenuLinks' href={`${txdomain}/app/tourneyX_prostaff/`}>TourneyX Pro Staff</a></li>
          <li><a className='sideMenuLinks' href={`${txdomain}/app/categories/`}>Categories</a></li>
          <li><a className='sideMenuLinks' href={`${txdomain}/app/clubs/`}>Clubs</a></li>
          <li><a className='sideMenuLinks' href={`${txdomain}/app/anglers/`}>Anglers</a></li>
          <li><a className='sideMenuLinks' href={`${txdomain}/app/dashboard/`}>My Dashboard</a></li>
          <li><a className='sideMenuLinks' href={`${txdomain}/app/logout/`}>Logout</a></li>
          <li><a className='sideMenuLinks' href={`${txdomain}/app/help/`}>Help</a></li>
        </ul>

        :
        
        <ul className="sideMenuList">
          <li><a className='sideMenuLinks' href={`${txdomain}`}>TourneyX</a></li>
          <li><a className='sideMenuLinks' href={`${txdomain}/app/tournaments/`}>Tournaments</a></li>
          <li><a className='sideMenuLinks' href={`${txdomain}/app/login/`}>Login</a></li>
          <li><a className='sideMenuLinks' href={`${txdomain}/app/angler-registration-request`}>Register as an Angler</a></li>
          <li><a className='sideMenuLinks' href={`${txdomain}/app/director-registration-request`}>Register as a Director</a></li>
    
          <li><a className='sideMenuLinks' href={`${txdomain}/app/help/`}>Help</a></li>
        </ul>

      }

   
  </div>

  <div id="leftMenu" className='left-nav-menu hidden' >
    <h3 className='search-header'>Search</h3>
    
    <Form id='searchForm'>
      <Form.Control type="text" title="Enter Tournament Name" 
        placeholder="Enter Tournament Name" className="mr-sm-2 search-input"
        onChange={setOnChange(setTourneyName)}></Form.Control>
      
      <Form.Control type="text" title="Enter City, State"
        placeholder="Enter City, State" className="mr-sm-2 search-input"
        onChange={setOnChange(setCityState)}/>
    </Form>

    <Button className="search-button" type="submit" onClick={(x) => search(x)} >Search</Button>
    <Button className="back-button" type="submit" onClick={() => toggleMenu()} >Back</Button>    

    
  </div>

  <div id="leftPinnedMenu" className='left-nav-menu hidden'>
    <div id="pinned-header">
      <div className="" id="pinned-content">
          <h3 className='pinned-search-header'>Pinned Tournaments</h3>
          {
                isShowPinIcon ?
                 
                  <ShowPinnedTournaments show_pinned_tournaments={get_pinned_tournaments} user_information={user_information} />
                  :null
          
          }
      </div>
     
    </div>
  
  </div>

  </>
)
}

export default Header

